import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-specific-section-controls',
    templateUrl: './specific-section-controls.component.html',
    styleUrls: ['./specific-section-controls.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BsDropdownModule, TooltipModule, TranslateModule],
})
export class SpecificSectionControlsComponent {
    public readonly disableDeleteEvent = input<boolean>(false);
    public readonly disableDeleteEventTooltip = input<string>('');
    public readonly isBlockHidden = input<boolean>(false);
    public readonly hideMoveUp = input<boolean>(false);
    public readonly hideMoveDown = input<boolean>(false);

    public readonly deleteEvent = output<void>();
    public readonly selectEvent = output<void>();
    public readonly addSection = output<void>();
    public readonly moveUpEvent = output<void>();
    public readonly moveDownEvent = output<void>();
    public readonly toggleMoreActionState = output<boolean>();

    public addSectionAction(): void {
        this.addSection.emit();
    }

    public deleteAction(): void {
        if (this.disableDeleteEvent()) {
            return;
        }

        this.deleteEvent.emit();
    }

    public moveUpAction(): void {
        this.moveUpEvent.emit();
    }

    public moveDownAction(): void {
        this.moveDownEvent.emit();
    }

    public selectAction(): void {
        this.selectEvent.emit();
    }

    public isShowDropDownMenu(state: boolean): void {
        this.toggleMoreActionState.emit(state);
    }
}
